<div class="sectionb">


    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>

    <form [formGroup]="myform" class="container-fluid" (ngSubmit)="saveModel()">
        <p class="form-hint">Fields with * are required</p>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="name">* Manufacturer </label>
            <div class="col-sm-9">
                <input class="form-control form-control-sm" id="name" formControlName="brand" type="text" required
                    placeholder="Enter manufacturer" [ngClass]="!myform.get('brand').valid ? 'is-invalid' :'' ">
                <div class="invalid-feedback" *ngIf="myform.get('brand').hasError('required')">
                    Manufacturer is required
                </div>
                <div class="invalid-feedback" *ngIf="myform.get('brand').hasError('minlength')">
                    Manufacturer must be at least 3 characters long.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="serial">* Serial </label>
            <div class="col-sm-9">
                <input class="form-control form-control-sm" id="serial" formControlName="serial" type="text" 
                    placeholder="Enter serial" [ngClass]="!myform.get('serial').valid ? 'is-invalid' :'' ">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="model">* Model </label>
            <div class="col-sm-9">
                <input class="form-control form-control-sm" id="model" formControlName="model" type="text" required
                    placeholder="Enter model" [ngClass]="!myform.get('model').valid ? 'is-invalid' :'' ">
                <div class="invalid-feedback" *ngIf="myform.get('model').hasError('required')">
                    Model is required
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="type">* Type </label>
            <div class="col-sm-9">
                <input class="form-control form-control-sm" id="type" formControlName="type" type="text" required
                    placeholder="Enter type" [ngClass]="!myform.get('type').valid ? 'is-invalid' :'' ">
                <div class="invalid-feedback" *ngIf="myform.get('type').hasError('required')">
                    Type is required
                </div>
            </div>
        </div>
<!--         <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="type">* Datasheet URL </label>
            <div class="col-sm-9">
                <input class="form-control form-control-sm" id="datasheet" formControlName="datasheet" type="text" 
                    placeholder="Enter datasheet URL" [ngClass]="!myform.get('datasheet').valid ? 'is-invalid' :'' ">
            </div>
        </div> -->

        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="longitud">*Electrical </label>
            <div class="col">
                <table>
                    <tr>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="power">*Power (W) </label>
                                <input class="form-control form-control-sm" id="longitud" formControlName="power"
                                    type="number" required placeholder="Enter Power in Watts"
                                    [ngClass]="!myform.get('power').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('power').hasError('required')">
                                    Power is required
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="efficency">*Efficency </label>
                                <input class="form-control form-control-sm" id="efficency" formControlName="efficency"
                                    type="number" required placeholder="Enter efficency "
                                    [ngClass]="!myform.get('efficency').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('efficency').hasError('required')">
                                    Efficency is required
                                </div>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="Imp">*Imp (A) </label>
                                <input class="form-control form-control-sm" id="Imp" formControlName="Imp" type="number"
                                    required placeholder="Enter Imp"
                                    [ngClass]="!myform.get('Imp').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('Imp').hasError('required')">
                                    Imp is required
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="Isc">*Isc (A)</label>
                                <input class="form-control form-control-sm" id="Isc" formControlName="Isc" type="number"
                                    required placeholder="Enter Isc"
                                    [ngClass]="!myform.get('Isc').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('Isc').hasError('required')">
                                    Isc is required
                                </div>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="Vmp">*Vmp (V)</label>
                                <input class="form-control form-control-sm" id="Vmp" formControlName="Vmp" type="number"
                                    required placeholder="Enter Vmp"
                                    [ngClass]="!myform.get('Vmp').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('Vmp').hasError('required')">
                                    Vmp is required
                                </div>
                            </div>
                        </td> 
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="Voc">*Voc (V)</label>
                                <input class="form-control form-control-sm" id="Voc" formControlName="Voc" type="number"
                                    required placeholder="Enter Voc"
                                    [ngClass]="!myform.get('Voc').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('Voc').hasError('required')">
                                    Voc is required
                                </div>
                            </div>
                        </td>
                        <td></td>
                        
                    </tr>
                </table>






            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="longitud">*Mechanical Data Dimensions </label>
            <div class="col">
                <table>
                    <tr>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="dimension_H">*Large mm</label>
                                <input class="form-control form-control-sm" id="dimension_H" formControlName="dimension_H"
                                    type="number" required placeholder="Enter large in mm"
                                    [ngClass]="!myform.get('dimension_H').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('dimension_H').hasError('required')">
                                    Large is required
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="dimension_W">*Width mm </label>
                                <input class="form-control form-control-sm" id="dimension_W" formControlName="dimension_W"
                                    type="number" required placeholder="Enter width in mm "
                                    [ngClass]="!myform.get('dimension_W').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('dimension_W').hasError('required')">
                                    Width is required
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="form-group col">
                                <label class="col-form-label" for="dimension_D">*Depth mm</label>
                                <input class="form-control form-control-sm" id="dimension_D" formControlName="dimension_D"
                                    type="number" required placeholder="Enter depth in mm "
                                    [ngClass]="!myform.get('dimension_D').valid ? 'is-invalid' :'' ">
                                <div class="invalid-feedback" *ngIf="myform.get('dimension_D').hasError('required')">
                                    Depth is required
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </form>
</div>